class BoxPricing extends HTMLElement {
  constructor() {
    super();
    this.variantPricing = new Map();
    this.packageOptionIndex = null;
  }

  connectedCallback() {
    this.loadVariantPricing();

    var currentVariantId = this.dataset.currentVariantId;
    if (currentVariantId) {
      this.update({ id: Number(currentVariantId) });
    }
  }

  update(variant) {
    if (!variant) {
      this.hideAll();
      return;
    }

    var record = this.getVariantRecord(variant.id);
    var savingsEl = this.querySelector('[data-box-savings-badge]');
    var isAvailable = typeof variant.available === 'boolean' ? variant.available : record && record.available;

    if (record && record.isBox && isAvailable) {
      this.updateSavingsBadge(savingsEl, record, variant.price);
    } else {
      if (savingsEl) savingsEl.style.display = 'none';
    }
  }

  loadVariantPricing() {
    var dataEl = this.querySelector('[data-box-pricing-variants]');
    if (!dataEl) return;

    try {
      var parsed = JSON.parse(dataEl.textContent);
      var variants = Array.isArray(parsed.variants) ? parsed.variants : [];

      this.packageOptionIndex = Number.isInteger(parsed.packageOptionIndex) ? parsed.packageOptionIndex : null;
      this.variantPricing = new Map();

      for (var i = 0; i < variants.length; i += 1) {
        var variant = variants[i];
        this.variantPricing.set(String(variant.id), variant);
      }
    } catch (error) {
      this.variantPricing = new Map();
      this.packageOptionIndex = null;
    }
  }

  getVariantRecord(variantId) {
    return this.variantPricing.get(String(variantId)) || null;
  }

  updateSavingsBadge(el, record, selectedBoxPrice) {
    if (!el) return;

    var singleVariantPrice = Number(record.pairedSingleVariantPrice);
    var unitsPerBox = parseInt(record.unitsPerBox, 10) || 0;
    var boxPrice = Number(selectedBoxPrice != null ? selectedBoxPrice : record.price);

    if (!singleVariantPrice || !unitsPerBox || Number.isNaN(boxPrice)) {
      el.style.display = 'none';
      return;
    }

    var expectedFullPrice = singleVariantPrice * unitsPerBox;
    var savings = expectedFullPrice - boxPrice;

    if (savings <= 0) {
      el.style.display = 'none';
      return;
    }

    var savingsPercent = Math.round((savings / expectedFullPrice) * 100);
    var savingsFormatted = Shopify.formatMoney(savings, window.money_format).replace(/<[^>]*>/g, '');
    var textEl = el.querySelector('span:last-child');

    if (textEl) {
      var template = this.dataset.savingsTemplate || 'Save {amount} ({percent}% off) when you buy a box of {count}';
      textEl.textContent = template
        .replace('{amount}', savingsFormatted)
        .replace('{percent}', savingsPercent)
        .replace('{count}', unitsPerBox);
    }

    el.dataset.singleUnitPrice = String(singleVariantPrice);
    el.dataset.unitsPerBox = String(unitsPerBox);
    el.dataset.pairedSingleVariantId = record.pairedSingleVariantId ? String(record.pairedSingleVariantId) : '';
    el.style.display = 'inline-flex';
  }

  hideAll() {
    var savingsEl = this.querySelector('[data-box-savings-badge]');
    if (savingsEl) savingsEl.style.display = 'none';
  }
}

customElements.define('box-pricing', BoxPricing);
